import { Grid, Pagination, Skeleton } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import CalledCard from "./calledcard";
import { FormattedMessage } from "react-intl";
import { PapiroConsole } from "src/utils/papiroConsole";
import Api from "src/services/api";
import { DialogFile } from "src/components/dialog-file";
import DialogGeneral from "src/components/dialog-general";
import RequesterHistoryDetailsModal from 'src/pages/called-accompaniment/components/requester-history-details-modal';

const LlmDocumentCalledsList = (props) => {
    const { intl, onShowNotification, onLoading, loading, refresh, match } = props
    const [calledLlmDocuments, setCalledLlmDocuments] = useState([])
    const [pageLlmDocument, setPageLlmDocument] = useState(1)
    const [totalLlmDocument, setTotalLlmDocument] = useState(0)
    const [totalPagesLlmDocument, setTotalPagesLlmDocument] = useState(0)
    const [pageStartLlmDocument, setPageStartLlmDocument] = useState(0)
    const [pageEndLlmDocument, setPageEndLlmDocument] = useState(10)
    const [openCalledDelete, setOpenCalledDelete] = useState(false)
    const [calledSelectedDelete, setCalledSelectedDelete] = useState(null)
    const [calledDetailItem, setCalledDetailItem] = useState(null)

    const openCalledDetail = (called) => setCalledDetailItem({
        id: called.id,
        type: 'called',
        calledId: called.id,
        title: called.title || '',
        displayTitle: called.title || ''
    })

    const closeCalledDetail = () => setCalledDetailItem(null)
    useEffect(() => {
        getCalleds()
    }, [refresh])

    const getCalleds = async (page = 1) => {
        let url = `/llmdocumentcalleds/paginate?page=${page}`;
        onLoading(true)
        await Api.get(url)
            .then((response) => {
                if (response) {
                    setTotalLlmDocument(response.data?.count)
                    setPagination(response.data?.count, page)
                    setCalledLlmDocuments(response.data.data)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const setPagination = (count, page) => {
        setTotalPagesLlmDocument(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStartLlmDocument(start)
        setPageEndLlmDocument(Math.min(start + 9, count))
    }

    const onChangePaginate = (event, value) => {
        setPageLlmDocument(value)
        getCalleds(value)
    }
    
    const onDelete = async () => {
        let url = `/llmdocumentcalleds/${calledSelectedDelete.id}`
        onLoading(true)
        await Api.delete(url)
            .then(async (response) => {
                if (response) {
                    await getCalleds(pageLlmDocument)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    return (
        <>
            <Grid container spacing={2}>
                {loading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                            <Skeleton variant="rectangular" width="100%" height={118} />
                        </Grid>
                    ))
                ) : (
                    calledLlmDocuments.map((item) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                            <CalledCard
                                item={item}
                                onClick={_ => {
                                    openCalledDetail(item)
                                }}
                                onDelete={_ => {
                                    setCalledSelectedDelete(item)
                                    setOpenCalledDelete(true)
                                }}
                                match={match}
                            />
                        </Grid>
                    ))
                )}
            </Grid>

            <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                    <Pagination count={totalPagesLlmDocument} page={pageLlmDocument} onChange={onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {pageStartLlmDocument} {<FormattedMessage id="to" />} {pageEndLlmDocument} {<FormattedMessage id="of" />} {totalLlmDocument} {<FormattedMessage id="register" />}
                </Grid>
            </Grid>

            <RequesterHistoryDetailsModal
                open={!!calledDetailItem}
                onClose={closeCalledDetail}
                item={calledDetailItem}
                intl={intl}
                setMessage={(isOpen, variant, message) => {
                    if (isOpen) {
                        onShowNotification(message, variant)
                    }
                }}
            />

            <DialogGeneral
                intl={intl}
                dialogTitle={calledSelectedDelete?.id + " - " + calledSelectedDelete?.title}
                dialogSubTitle="Você realmente deseja remover este chamado da llm?"
                open={openCalledDelete}
                openOrCloseModalFunction={setOpenCalledDelete}
                handleConfirmation={onDelete}
            />
        </>
    )
}

export default LlmDocumentCalledsList